<template>
    <div v-show="isVisible"
         class="lw-cols multiple-rows multiple-rows-tl one-row-tp multiple-rows-sl multiple-rows-sp main mb-5rem">
        <authentication-component v-if="!signedIn" 
                                  ref="authenticationComponent" 
                                  v-bind="authenticationComponentProps"
                                  class="full-width"/>
    </div>
</template>
<script>
    import AuthenticationComponent from "../../authentication/AuthenticationComponent";

    export default {
        name: "PaymentAuthentication",

        mixins: [],
        data() {
            return {
                componentType: "PaymentAuthentication",
                rendersWithVue: true,                
                show: true,
                hasAuthenticated: false
            }
        },
        computed: {
            signedIn(){
                return false;
            },
            contextWrapper() {
                return this.hasContext("payment-manager") 
                    ? this.findNodeState(this.hasContext("payment-manager")[0].id) 
                    : null;
            },
            authenticationComponentProps() {
                return {
                    successLoginCallback: this.successLogin,
                    successRegistrationCallback: this.successRegister,
                    showSubmitButtons: false,
                    showForgotPassword: false,
                    withoutTerms: true,
                    withoutMarketingOptIn: true,
                    onlyRequiredFields: this.myData.onlyRequiredFields,
                    additionalAuthenticatonFormData: this.contextWrapper?.additionalAuthenticatonFormData || {}
                }
            },
            getDefaultDataStructure() {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    styles: null,
                    onlyRequiredFields: false,
                    visibilityStatus: true,
                    itemVisibilitySettings: null
                }
            },
            isVisible() {
                return this.getVisibilityStatus &&
                    this.show &&
                    !this.signedIn &&
                    !this.isPageContext('payment');
            },

            getVisibilityStatus() {
                return this.myData.visibilityStatus;
            }
        },
        methods: {
            validate() {
                return new Promise((resolve, reject) => {                    
                    if (this.signedIn) {                        
                       return resolve();
                    }
                    this.$refs.authenticationComponent.authenticate().then((e) => {
                        this.hasAuthenticated = true;
                        resolve();
                    }).catch(error => {
                        reject();
                    });
                });
            },
            successLogin() {
                
            },
            successRegister() {
                
            },
            setVisibility(val) {
                this.show = val;
            }
        },

        components: {
            AuthenticationComponent
        }
    }
</script>
